module.exports = __webpack_public_path__ + "static/media/icon-recommends.8e0406d8.svg";